"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _footerModule = _interopRequireDefault(require("./footer.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(props) {
  var id = props.id,
      linksList = props.linksList,
      registrationText = props.registrationText,
      socialArray = props.socialArray;
  var year = new Date();
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: _footerModule.default["footer"],
    "data-tag": "/"
  }, _react.default.createElement("ul", {
    id: id ? "".concat(id, "_footer_list") : null,
    className: _footerModule.default["social"],
    "aria-label": "Soziale Netzwerke",
    role: "navigation"
  }, socialArray && socialArray.map(function (item, index) {
    return _react.default.createElement("li", {
      key: item.name,
      id: id ? "".concat(id, "_footer_item_").concat(index) : null
    }, _react.default.createElement("a", {
      id: id ? "".concat(id, "_footer_item_").concat(index, "_link") : null,
      href: item.href,
      target: "_blank",
      title: item.title
    }, _react.default.createElement("div", {
      id: id ? "".concat(id, "_footer_item_").concat(index, "_name") : null,
      className: "".concat(_footerModule.default['icon'], " ").concat(_footerModule.default[item.name])
    }, _react.default.createElement("div", {
      id: id ? "".concat(id, "_footer_item_").concat(index, "_screenreaderOnly") : null,
      className: _footerModule.default["screenreaderOnly"]
    }, item.name))));
  }), _react.default.createElement("li", {
    className: _footerModule.default["clearboth"]
  })), _react.default.createElement("ul", {
    id: id ? "".concat(id, "_footer_element_list") : null,
    className: _footerModule.default["metanav2"]
  }, linksList && linksList.length > 0 && linksList.map(function (link, index) {
    return _react.default.createElement("li", {
      id: id ? "".concat(id, "_footer_element_").concat(index) : null,
      key: index
    }, link.element);
  })), _react.default.createElement("div", {
    id: id ? "copyright" : null,
    className: _footerModule.default["copyright"],
    role: "contentinfo"
  }, "\xA9 ", year.getFullYear(), " ARAG"), _react.default.createElement("div", {
    className: _footerModule.default["clearboth"]
  }), _react.default.createElement("div", {
    id: id ? "registration" : null,
    className: _footerModule.default["registration"],
    dangerouslySetInnerHTML: registrationText ? {
      __html: registrationText
    } : null
  }));
};

Footer.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Array of Object with property element. Is a list with Links that you can add to the footer*/
  linksList: _propTypes.default.arrayOf(_propTypes.default.shape({
    element: _propTypes.default.oneOfType([_propTypes.default.object.isRequired, _propTypes.default.string.isRequired])
  })),
  socialArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** String text that specifies the name of social media. Also it is used for styling*/
    name: _propTypes.default.string,

    /** String text that specifies the url of social media*/
    href: _propTypes.default.string,

    /** String text that specifies accessibility of the icon*/
    title: _propTypes.default.string
  })),

  /** Element for registration content*/
  registrationElement: _propTypes.default.element
};
var _default = Footer;
exports.default = _default;